import { Link } from "react-router-dom";
import type { Film } from "@/types/content";

interface FilmCardProps {
  film: Film;
}

export default function FilmCard({ film }: FilmCardProps) {
  return (
    <Link
      to={`/detail/film/${film.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={film.cover}
          alt={`${film.title} 影视海报`}
          title={`${film.title} 影视作品 巨乳娱乐资讯网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
          <i className="ri-star-fill text-[11px]" aria-hidden="true"></i>
          {film.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="line-clamp-1 text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
          {film.title}
        </h3>
        <p className="line-clamp-1 text-xs text-foreground-500">
          {film.year} · {film.region} · {film.genres.join(" / ")}
        </p>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {film.summary}
        </p>
      </div>
    </Link>
  );
}